import { RoleDto } from "../app/model/api/types/dto/roleDto";

export class RoleViewModel {
  id?: string | null;
  name: string | null;

  constructor(id: string | null, name: string | null) {
    this.id = id;
    this.name = name;
  }

  toDto(): RoleDto {
    return {
      id: this.id,
      name: this.name,
    };
  }

  mapFromDto(dto: RoleDto): void {
    this.id = dto.id;
    this.name = dto.name;
  }
}
